export default [
  {
    width: 1024,
    name: 'portable',
    groupSize: 4
  },
  {
    width: 769,
    name: 'ipad',
    groupSize: 3
  }
]



// WEBPACK FOOTER //
// ./src/global/js/breakpoints.js